import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

// Selector-less directive so subclasses keep a real ɵdir. An @Injectable base
// with ngOnDestroy is recompiled by the test JIT, which replaces ɵfac with a
// getter and then breaks the next component bundle.
@Directive({ standalone: false })
export class DestroyerBase implements OnDestroy {
  protected readonly _destroyerRef = new Subject<boolean>();

  ngOnDestroy(): void {
    this._destroyerRef.next(true);
    this._destroyerRef.complete();
  }
}
